import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/Choicest_Fruit.png";
import Card from "react-bootstrap/Card";


function About() {

   return (
   
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Who <strong className="purple">We Are </strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
             <img src={laptopImg} alt="about" className="img-fluid" />
          
            </Col>
      
                  
      
        </Row>
        <h1 className="project-heading">
          Our  <strong className="purple">Core Values </strong>
        </h1>
        <Card className="quote-card-view">
             <Card.Body>
               <blockquote className="blockquote mb-0">
                 <p className="about-text">
                  <li><span className="purple">Ethical Innovation</span></li>
                  developing and applying technology in ways that promote equity, responsibility, and human well-being.
                 </p>
       
                 <p className="about-text">
                  <li><span className="purple">Service & Collaboration</span></li>
                  working hand-in-hand with neighbors, partners, and organizations to address pressing challenges.
                 </p>

                 <p className="about-text">
                  <li><span className="purple">Inclusivity & Community</span></li>
                  We embrace diverse perspectives, ensuring that everyone has a voice, role, and place in our initiatives, and every action we take prioritizes the well-being, growth, and connectedness of communities.
                 </p>

                 <p className="about-text">
                  <li><span className="purple">Grassroots Outreach</span></li>
                 Through public events, community meetings, and one-on-one conversations, we spread our mission and attract those who share our passion for positive change.
                 </p>            
                 
                 <footer className="blockquote-footer"></footer>
               </blockquote>
             </Card.Body>
           </Card>

        <Techstack />

        

      
      </Container>
    </Container>
  

  );
}

export default About;
